import { render, staticRenderFns } from "./EmptyEventMessage.vue?vue&type=template&id=55aebd37&scoped=true&"
import script from "./EmptyEventMessage.vue?vue&type=script&lang=ts&"
export * from "./EmptyEventMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aebd37",
  null
  
)

export default component.exports